// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3615":"639eee31","6593":"bc215da1"}[chunkId] + ".chunk.css";
};